import * as React from 'react'

export function useInterval(callback: () => void, delay: number | null): void {
  const savedCallback = React.useRef(() => {})

  React.useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  React.useEffect(() => {
    function tick(): void {
      savedCallback.current()
    }
    if (delay !== null) {
      const id = window.setInterval(tick, delay)
      return () => window.clearInterval(id)
    }
  }, [delay])
}
